import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { ElementRefPropType } from 'utils/PropTypesValues';

const PageLayout = ({
  classes,
  children,
  grey,
  padding,
  withTabs,
  withDrawer,
  withChips,
  withFloater,
  isTopPadded,
  pageLayoutRef,
  handleScroll,
}) => {
  const customPadding = padding ? { padding } : {};
  let scrollClass;
  if (isTopPadded) {
    scrollClass = withTabs ? classes.scrollAreaWithTabsAndTopPadded : classes.scrollAreaWithTopPadded;
  } else {
    scrollClass = withTabs ? classes.scrollAreaWithTabs : classes.scrollArea;
  }
  return (
    <div
      onScroll={handleScroll}
      ref={pageLayoutRef}
      className={cx(
        classes.content,
        grey && classes.grey,
        scrollClass,
        withDrawer && classes.scrollAreaWithHeaderAndDrawer,
        withChips && classes.scrollAreaWithChips,
        withFloater && classes.scrollAreaWithFloatingHeader,
      )}
      style={{ ...customPadding }}
    >
      {children}
    </div>
  );
};

PageLayout.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  children: PropTypes.node,
  grey: PropTypes.bool,
  withTabs: PropTypes.bool,
  withDrawer: PropTypes.bool,
  withFloater: PropTypes.bool,
  padding: PropTypes.string,
  isTopPadded: PropTypes.bool,
  pageLayoutRef: ElementRefPropType,
};

PageLayout.defaultProps = {
  children: '',
  classes: {},
  grey: false,
  withTabs: false,
  withDrawer: false,
  withFloater: false,
  isTopPadded: false,
};

export default PageLayout;
